import {combineReducer} from '../base/fsa/combineReducer';
import {ControlState, initialControlState} from './control/state';
import {controlReducer} from './control/reducer';
import {debugReducer} from './debug/reducer';
import {DebugState, initialDebugState} from './debug/state';
import {uiReducer} from './ui/reducer';
import {initialUIState, UIState} from './ui/state';
import {initialSettingsState, SettingsState} from './settings/state';
import {settingsReducer} from './settings/reducers';
import {setupReducer} from './setup/reducer';
import {initialSetupState, SetupState} from './setup/state';
import {initialTemperatureState, TemperatureMessage} from './temperature/state';
import {temperatureReducer} from './temperature/reducer';
import {UserState} from './user/state';
import {initialUserState, userReducer} from './user/reducer';
import {persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

export type ApplicationState = {
    control: ControlState;
    debug: DebugState;
    settings: SettingsState;
    ui: UIState;
    setup: SetupState;
    temperature: TemperatureMessage;
    user: UserState;
};

export const initialAppState: ApplicationState = {
    control: initialControlState,
    debug: initialDebugState,
    settings: initialSettingsState,
    ui: initialUIState,
    setup: initialSetupState,
    temperature: initialTemperatureState,
    user: initialUserState,
};

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['selectedBackground'],
};

const persistedBackgroundReducer = persistReducer(persistConfig, uiReducer);

export const appReducer = combineReducer<ApplicationState>({
    control: controlReducer,
    debug: debugReducer,
    settings: settingsReducer,
    ui: persistedBackgroundReducer,
    setup: setupReducer,
    temperature: temperatureReducer,
    user: userReducer,
}, initialAppState);
